import { get } from '../HTTP';
import { CertificateModel } from '../model/CertificateModel';
import { showAlert } from '../actions/miscellaneousActions';
import { getUserData } from './utilityServices';

export async function getAllCertificates(userId = '') {
    try {
        let response = null;
        let responses = null;

        const userData = getUserData();
        const category = userData.category || 'all';
        if (!userId) {
            response = await get(`/Certificates/${category}`, {});
            // responses = await get(`/GetRequestedModules/${category}`, {});
        } else {
            response = await get(`/GetUserCertificate/${userId}/${category}`, {});
        }
        // (response.data ? (response.data.Certificates || response.data) : [] || []).forEach((instance, index) => {
        (response.data ? (response.data.Certificates || response.data) : [] || []).forEach((instance, index) => {
            instance.id = `${index + 1}`;
            instance.userName = instance.UserName || instance.Name;
            instance.certificateLink = instance.CertificateLink || instance.Link;
            instance.certificateName = instance.CertificateName || instance.Name;
            instance.moduleName = instance.ModuleName || instance.M_Name;
            instance.dateCreated = instance.DateCompleted || instance.Date
            instance.category = instance.Category || instance.Category;
            new CertificateModel(instance).$save();
        });

    } catch (error) {
        showAlert({
            title: 'Oops..!!',
            text: error,
            type: 'error',
            closeOnConfirm: true
        },
            'submission');
        throw new Error(error);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/certificateService.ts